// 1. New array added by "New class subject button" is called newArr
// newArr can be found in line 469
// api passed on 146,171,724,632,276
// table change 650
// change of label fields 432,458,519

import React,{useState,useEffect} from 'react'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsStatus, optionsSubject, roledrp } from '../../Helper'
import moment from 'moment'

import { newsApi } from '../../../utils/AdminDashApi/NewsApi'

import { periodEntryApi } from '../../../utils/AdminDashApi/PeriodEntryApi'
import { fetchPeriodAlertStatusDrpDown, fetchPeriodNameDrpDown, fetchPeriodStatusDrpDown } from '../../../utils/Api_Calls/api_calls_all';

const PeriodEntryComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [sessionname,setsessionname] = useState("")
  const [sessionname2,setsessionname2] = useState("")
  const [startdate,setstartdate] = useState("")
  const [enddate,setenddate] = useState("")
  const [statusmod1,setstatusmod1] = useState("")
  const [statusmod2,setstatusmod2] = useState("")
  const [periodnamemod1,setperiodnamemod1] = useState("")
  const [descmod1,setdescmod1] = useState("")  
  const [alertstatusmod1,setalertstatusmod1] = useState("")  
  const [discountmod1,setdiscountmod1] = useState("")  
  const [periodyearmod1,setperiodyearmod1] = useState("")  
  const [billlastdatemod1,setbilllastdatemod1] = useState("")  
    
  
  
  const [borderstartdate,setborderstartdate] = useState("")   
  const [borderenddate,setborderenddate] = useState("")
  const [bordersessionname,setbordersessionname] = useState(false)
  const [borderstatusmod1,setborderstatusmod1] = useState("")
  const [borderperiodnamemod1,setborderperiodnamemod1] = useState("")
  const [borderdescmod1,setborderdescmod1] = useState("")  
  const [borderalertstatusmod1,setborderalertstatusmod1] = useState("")  
  const [borderdiscountmod1,setborderdiscountmod1] = useState("")  
  const [borderperiodyearmod1,setborderperiodyearmod1] = useState("")  
  const [borderbilllastdatemod1,setborderbilllastdatemod1] = useState("")  
  
  const [labelsessionname,setlabelsessionname] = useState("")
  const [labelstartdate,setlabelstartdate] = useState("")    
  const [labelenddate,setlabelenddate] = useState("")
  const [labelstatusmod1,setlabelstatusmod1] = useState("")
  const [labelalertstatusmod1,setlabelalertstatusmod1] = useState("")
  const [labelperiodnamemod1,setlabelperiodnamemod1] = useState("")
  const [labeldescmod1,setlabeldescmod1] = useState("")  
  const [labeldiscountmod1,setlabeldiscountmod1] = useState("")  
  const [labelperiodyearmod1,setlabelperiodyearmod1] = useState("")  
  const [labelbilllastdatemod1,setlabelbilllastdatemod1] = useState("")  

  
    const [startdate2,setstartdate2] = useState("")
    const [enddate2,setenddate2] = useState("")
    
    
    const [borderstartdate2,setborderstartdate2] = useState("")   
    const [borderenddate2,setborderenddate2] = useState("")
    const [bordersessionname2,setbordersessionname2] = useState(false)
    
    
    const [labelsessionname2,setlabelsessionname2] = useState("")
    const [labelstartdate2,setlabelstartdate2] = useState("")    
    const [labelenddate2,setlabelenddate2] = useState("")
    

    const [borderstatusmod2,setborderstatusmod2] = useState("")
    const [borderperiodnamemod2,setborderperiodnamemod2] = useState("")
    const [borderdescmod2,setborderdescmod2] = useState("")  
    const [borderalertstatusmod2,setborderalertstatusmod2] = useState("")  
    const [borderdiscountmod2,setborderdiscountmod2] = useState("")  
    const [borderperiodyearmod2,setborderperiodyearmod2] = useState("")  
    const [borderbilllastdatemod2,setborderbilllastdatemod2] = useState("") 

    
    const [labelstatusmod2,setlabelstatusmod2] = useState("")
    const [labelalertstatusmod2,setlabelalertstatusmod2] = useState("")
    const [labelperiodnamemod2,setlabelperiodnamemod2] = useState("")
    const [labeldescmod2,setlabeldescmod2] = useState("")  
    const [labeldiscountmod2,setlabeldiscountmod2] = useState("")  
    const [labelperiodyearmod2,setlabelperiodyearmod2] = useState("")  
    const [labelbilllastdatemod2,setlabelbilllastdatemod2] = useState("") 

    
    const [periodnamemod2,setperiodnamemod2] = useState("")
    const [descmod2,setdescmod2] = useState("")  
    const [alertstatusmod2,setalertstatusmod2] = useState("")  
    const [discountmod2,setdiscountmod2] = useState("")  
    const [periodyearmod2,setperiodyearmod2] = useState("")  
    const [billlastdatemod2,setbilllastdatemod2] = useState("")

    const [chkbxsetdefaultmod1,setchkbxsetdefaultmod1] = useState("")
    const [chkbxsetdefaultmod2,setchkbxsetdefaultmod2] = useState("")

  const handlechkbxsetdefaultmod1=(event)=>{
    if (event.target.checked) {
            
    } else {
      
    }
    setchkbxsetdefaultmod1(current => !current);
  }
  const handlechkbxsetdefaultmod2=(event)=>{
    if (event.target.checked) {
            
    } else {
      
    }
    setchkbxsetdefaultmod2(current => !current);
  }
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        //console.log("past")
      } else {
        //console.log("future")
      }
  },[])
  const [classdrp,setClassdrp] = useState("")
  
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myid)    
  }
  const [PeriodListResponse, setPeriodListResponse] = useState([]);
  const [PeriodNameResponse, setPeriodNameResponse] = useState([]);
  const [PeriodStatusResponse, setPeriodStatusResponse] = useState([]);
  const [PeriodAlertStatusResponse, setPeriodAlertStatusResponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
    useEffect(() => {
      const fetchPeriodList = async () => {
        try {
          const response = await axios.get(
            "https://localhost:7229/api/Admin/ActiveSessionPeriodList",
            {},
            headers
          );
          setPeriodListResponse(response.data);
          setsessionname(response.data.item1);
          // console.log(classresponse);
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      };
      fetchPeriodList();

      const fetchPeriodName = async () => {
        const data = await fetchPeriodNameDrpDown();
        setPeriodNameResponse(data);
      };
      fetchPeriodName();

      const fetchPeriodStatus = async () => {
        const data = await fetchPeriodStatusDrpDown();
        setPeriodStatusResponse(data);
      };
      fetchPeriodStatus();

      const fetchPeriodAlertStatus = async () => {
        const data = await fetchPeriodAlertStatusDrpDown();
        setPeriodAlertStatusResponse(data);
      };
      fetchPeriodAlertStatus();
    }, [PeriodListResponse]);
    const [show3, setShow3] = useState(false);

    const handleClose2=()=>{
      setShow3(false)
    }
    const [modalitem,setmodalitem] = useState(null)
    const [PeriodNamePopulate,setPeriodNamePopulate] = useState(null)
    const [PeriodStatusPopulate,setPeriodStatusPopulate] = useState(null)
    const [PeriodAlertStatusPopulate,setPeriodAlertStatusPopulate] = useState(null)
    
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      setmodalitem(myitem)
      setrolemodalvalue2(myitem.rolename)
      setsessionname2(myitem.session)
      setdescmod2(myitem.description)
      setdiscountmod2(myitem.discount)
      setperiodyearmod2(myitem.periodYear)
      setperiodnamemod2(myitem.periodName)
      setstartdate2(myitem.startDate)
      setenddate2(myitem.endDate)
      setstatusmod2(myitem.status)
      setalertstatusmod2(myitem.alertStatus)
      setbilllastdatemod2(myitem.billinG_LAST_DATE)
      DrpdownValueSetPeriodName(PeriodNameResponse,myitem.periodName,setPeriodNamePopulate)
      DrpdownValueSet(PeriodStatusResponse,myitem.status,setPeriodStatusPopulate)
      DrpdownValueSetPeriodName(PeriodAlertStatusResponse,myitem.alertStatus,setPeriodAlertStatusPopulate)

    };
    function DrpdownValueSetPeriodName(res,myval,setter){
      const matchedItem = res.find(
          (item) => (item.opt == myval)
        );
        if (matchedItem) {
          setter(matchedItem.opt);
          
        } else {
          setter("");
        }
  }
    function DrpdownValueSet(res, myval, setter) {
      const matchedItem = res.find((item) => item.id == myval);
      if (matchedItem) {
        setter(matchedItem.opt);
      } else {
        setter("");
      }
    }
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(periodEntryApi.data)


  const mainfilter=(searchkey,arr)=>{
    let filteredArr = [];

    if (searchkey) {
      filteredArr = arr.filter((item) => {
        const searchMatch = item.subjectname
          .toLowerCase()
          .includes(searchkey.toLowerCase());
        return searchMatch;
      });
    } else {
      filteredArr = arr.filter((item) => {
        return item;
      });
    }

    setfilteredArr(filteredArr);
    }



  const [tempfilteredarr,settempfilteredarr] = useState([])
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;        
        setCurrentItems(periodEntryApi.data.slice(itemOffset, endOffset));        
        setPageCount(Math.ceil(periodEntryApi.data.length / itemsPerPage));
        
      }, [itemOffset, itemsPerPage]);
      let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      useEffect(()=>{
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
        setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
        setpagecountoffilter(filteredArr.length)
      },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
    
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % periodEntryApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [subjectnamemodalvalue,setsubjectnamemodalvalue] = useState("")
      const [classnamemodalvalue,setclassnamemodalvalue] = useState("")
      
      const [subjectnamemodalvalue2,setsubjectnamemodalvalue2] = useState("")
      const [classnamemodalvalue2,setclassnamemodalvalue2] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
      const drpfuncclassnamemodal=(mystatus,myid)=>{
        setclassnamemodalvalue(myid)
        
          
      }
      const drpfuncclassnamemodal2=(mystatus,myid)=>{
        setclassnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal=(mystatus,myid)=>{
        setrolemodalvalue(mystatus)
        
          
      }
      const drpfuncsubjectnamemodal=(mystatus,myid)=>{
        setsubjectnamemodalvalue(myid)
        
          
      }
      const drpfuncsubjectnamemodal2=(mystatus,myid)=>{
        setsubjectnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal2=(mystatus,myid)=>{
        setrolemodalvalue2(mystatus)
        console.log("manualselect" , mystatus)
          
      }
      
      const handlesearch =()=>{
    
        setactivefrom("")
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
      console.log(rolemodalvalue2)
      setShow3(false)
    }

   
   

    useEffect(()=>{
      
        mainfilter(mainpagesearch,periodEntryApi.data)      

      
    },[mainpagesearch])
    
    const handleActiveFrom = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
    const [activefromModal1,setactivefromModal1] = useState("")
    const handlestartdateModal1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(moment(dtfinalc).format("YYYY-MM-DD"))
            setstartdate(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
    const handlestartdateModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(moment(dtfinalc).format("YYYY-MM-DD"))
            setstartdate2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
    const handlebilllastdateModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setbilllastdatemod2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
    const [activeToModal1,setactiveToModal1] = useState("")
      const handleenddateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setenddate(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
      const handlebilllastdateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setbilllastdatemod1(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
      const handleenddateModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setenddate2(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
    const [newsDate1,setnewsDate1] = useState("")
      const handlenewsDateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate1(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
    const [newsDate2,setnewsDate2] = useState("")
      const handlenewsDateModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate2(moment(dtfinalc).format("YYYY-MM-DD"))

            
        }
        
        
    }
    // Modal2activefromto 
    
    const handleActiveFrom2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
    const [activefromModal2,setactivefromModal2] = useState("")
    const handleActiveFromModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal2(moment(dtfinalc).format("YYYY-MM-DD"))
        }
        
        
    }
      const handleActiveTo2 = (activetoval)=>{
        if(activetoval != null){
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo2(moment(dtfinalc).format("YYYY-MM-DD"))
        } 
    }
    const [activeToModal2,setactiveToModal2] = useState("")
      const handleActiveToModal2 = (activetoval)=>{
        if(activetoval != null){
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveToModal2(moment(dtfinalc).format("YYYY-MM-DD")) 
        }
    }
    

   
   
    const [subgroupdesMod2,setsubgroupdesMod2] = useState("")
    const handlesubgroupdesMod2=(e)=>{
        setsubgroupdesMod2(e.target.value)
    }
   
    const [newsTitleMod1,setnewsTitleMod1] = useState("")
    const handlenewsTitleMod1=(e)=>{
        setnewsTitleMod1(e.target.value)
    }
    const [newsTitleMod2,setnewsTitleMod2] = useState("")
    const handlenewsTitleMod2=(e)=>{
        setnewsTitleMod2(e.target.value)
    }
    const [descriptionMod1,setdescriptionMod1] = useState("")
    const handledescriptionMod1=(e)=>{
        setdescriptionMod1(e.target.value)
    }
    const [descriptionMod2,setdescriptionMod2] = useState("")
    const handledescriptionMod2=(e)=>{
        setdescriptionMod2(e.target.value)
    }


     
    const [activefromModal1label,setactivefromModal1label] = useState("")
    const [newsDatelabel,setnewsDatelabel] = useState("")
    const [activetoModal1label,setactivetoModal1label] = useState("")
    const [newsTitleMod1label,setnewsTitleMod1label] = useState("")
    const [descriptionMod1label,setdescriptionMod1label] = useState("")
    
    const [descriptionMod2label,setdescriptionMod2label] = useState("")
    const [activefromModal1label2,setactivefromModal1label2] = useState("")
    const [newsDatelabel2,setnewsDatelabel2] = useState("")
    const [activetoModal1label2,setactivetoModal1label2] = useState("")
    const [newsTitleMod2label,setnewsTitleMod2label] = useState("")

    const drpfunctionstatusmod1=(myval,myid)=>{
      setstatusmod1(myid)
    }
    const drpfunctionstatusmod2=(myval,myid)=>{
      setstatusmod2(myid)
    }
    const drpfunctionalertstatusmod2=(myval,myid)=>{
      setalertstatusmod2(myid)
    }
    const drpfunctionalertstatusmod1=(myval,myid)=>{
      setalertstatusmod1(myid)
    }
    const drpfunctionperiodnamemod2=(myval,myid)=>{
      setperiodnamemod2(myval)
    }
    const drpfunctionperiodnamemod1=(myval,myid)=>{
      setperiodnamemod1(myval)
    }

    // Validation 

    const handlesaveModal1 = async () => {
      if (startdate.length == 0) {
        setlabelstartdate("Start Date Required");
        setborderstartdate("err");
      } else {
        setlabelstartdate("");
        setborderstartdate("");
      }
      if (enddate.length == 0) {
        setlabelenddate("End Date Required");
        setborderenddate("err");
      } else {
        setlabelenddate("");
        setborderenddate("");
      }
      if (billlastdatemod1.length == 0) {
        setlabelbilllastdatemod1("Bill last Date Required");
        setborderbilllastdatemod1("err");
      } else {
        setlabelbilllastdatemod1("");
        setborderbilllastdatemod1("");
      }
      if (!sessionname && sessionname == "") {
        setlabelsessionname("Session name required");
        setbordersessionname(true);
      } else {
        setlabelsessionname("");
        setbordersessionname(false);
      }

      if (statusmod1.length === 0) {
        setlabelstatusmod1("Status Required");
        setborderstatusmod1("err");
      } else {
        setlabelstatusmod1("");
        setborderstatusmod1("");
      }
      if (!periodnamemod1 && periodnamemod1 == "") {
        setlabelperiodnamemod1("Period Name Required");
        setborderperiodnamemod1("err");
      } else {
        setlabelperiodnamemod1("");
        setborderperiodnamemod1(false);
      }
      if (!descmod1 && descmod1 == "") {
        setlabeldescmod1("Description Required");
        setborderdescmod1(true);
      } else {
        setlabeldescmod1("");
        setborderdescmod1(false);
      }
      if (!statusmod1 && statusmod1 == "") {
        setlabelstatusmod1("Status Required");
        setborderstatusmod1("err");
      } else {
        setlabelstatusmod1("");
        setborderstatusmod1(false);
      }
      if (alertstatusmod1.length ===0) {
        setlabelalertstatusmod1("Alert Status Required");
        setborderalertstatusmod1("err");
      } else {
        setlabelalertstatusmod1("");
        setborderalertstatusmod1(false);
      }
      // if (!discountmod1 && discountmod1 == "") {
      //   setlabeldiscountmod1("Discount Required");
      //   setborderdiscountmod1(true);
      // } else {
      //   setlabeldiscountmod1("");
      //   setborderdiscountmod1(false);
      // }
      if (!periodyearmod1 && periodyearmod1 == "") {
        setlabelperiodyearmod1("Period Year Required");
        setborderperiodyearmod1(true);
      } else {
        setlabelperiodyearmod1("");
        setborderperiodyearmod1(false);
      }
      if (
        startdate.length !== 0 &&
        enddate.length !== 0 &&
        billlastdatemod1.length !== 0 &&
        sessionname &&
        statusmod1.length !== 0 &&
        alertstatusmod1.length !==0 &&
        // discountmod1 &&
        periodyearmod1
      ) {
        const finalArr={
          "perioD_ID": 0,
          "perioD_NAME": periodnamemod1,
          "description": descmod1,
          "starT_DATE": startdate,
          "enD_DATE": enddate,
          "status": statusmod1.toString(),
          "perioD_YEAR": periodyearmod1,
          "sessioN_ID": null,
          "attributE1": alertstatusmod1.toString(),
          "attributE5": discountmod1,
          "createD_BY": null,
          "lasT_UPDATE_BY": null,
          "billinG_LAST_DATE": billlastdatemod1,
      }
      await SaveOrUpdatePeriodInfo(finalArr);
        console.log("Done");
        setShow2(false);
      } else {
        toast.error("Fill out all required fields", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    };
    
    const handlesaveModal2 = async () => {
      if (startdate2.length == 0) {
        setlabelstartdate2("Start Date Required");
        setborderstartdate2("err");
      } else {
        setlabelstartdate2("");
        setborderstartdate2("");
      }
      if (enddate2.length == 0) {
        setlabelenddate2("End Date Required");
        setborderenddate2("err");
      } else {
        setlabelenddate2("");
        setborderenddate2("");
      }
      if (!sessionname2 && sessionname2 == "") {
        setlabelsessionname2("Session name required");
        setbordersessionname2(true);
      } else {
        setlabelsessionname2("");
        setbordersessionname2(false);
      }

      if (statusmod2.length === 0) {
        setlabelstatusmod2("Status Required");
        setborderstatusmod2("err");
      } else {
        setlabelstatusmod2("");
        setborderstatusmod2(false);
      }
      if (billlastdatemod2.length == 0) {
        setlabelbilllastdatemod2("Bill last Date Required");
        setborderbilllastdatemod2("err");
      } else {
        setlabelbilllastdatemod2("");
        setborderbilllastdatemod2("");
      }
      if (!periodnamemod2 && periodnamemod2 == "") {
        setlabelperiodnamemod2("Period Name Required");
        setborderperiodnamemod2("err");
      } else {
        setlabelperiodnamemod2("");
        setborderperiodnamemod2(false);
      }
      if (!descmod2 && descmod2 == "") {
        setlabeldescmod2("Description Required");
        setborderdescmod2(true);
      } else {
        setlabeldescmod2("");
        setborderdescmod2(false);
      }
      if (alertstatusmod2.length==0) {
        setlabelalertstatusmod2("Alert Status Required");
        setborderalertstatusmod2("err");
      } else {
        setlabelalertstatusmod2("");
        setborderalertstatusmod2(false);
      }
      if (!discountmod2 && discountmod2 == "") {
        setlabeldiscountmod2("Discount Required");
        setborderdiscountmod2(true);
      } else {
        setlabeldiscountmod2("");
        setborderdiscountmod2(false);
      }
      if (!periodyearmod2 && periodyearmod2 == "") {
        setlabelperiodyearmod2("Period Year Required");
        setborderperiodyearmod2(true);
      } else {
        setlabelperiodyearmod2("");
        setborderperiodyearmod2(false);
      }
      if (
        startdate2.length !== 0 &&
        enddate2.length !== 0 &&
        billlastdatemod2.length !== 0 &&
        sessionname2 &&
        statusmod2.length !== 0 &&
        alertstatusmod2.length !== 0 &&
        discountmod2 &&
        periodyearmod2
      ) {
        const finalArr={
            "perioD_ID": modalitem.periodId?modalitem.periodId:null,
            "perioD_NAME": periodnamemod2,
            "description": descmod2,
            "starT_DATE": startdate2,
            "enD_DATE": enddate2,
            "status": statusmod2.toString(),
            "perioD_YEAR": periodyearmod2,
            "sessioN_ID": null,
            "attributE1": alertstatusmod2.toString(),
            "attributE5": discountmod2,
            "createD_BY": null,
            "lasT_UPDATE_BY": null,
            "billinG_LAST_DATE": billlastdatemod2,
        }
        await SaveOrUpdatePeriodInfo(finalArr);
        console.log("Done");
        setShow3(false);
      } else {
        toast.error("Fill out all required fields", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    };
    
    async function SaveOrUpdatePeriodInfo(data) {
      console.log(data);
      try {
        axios
          .post(
            "https://localhost:7229/api/Admin/SaveOrUpdatePeriod",
            data,
            headers
          )
          .then(function (response) {
            console.log(response.data)
            setPeriodListResponse(response.data);
            const foundErrorItem = response.data.item1.length > 0;
            console.log(foundErrorItem)
            if(!foundErrorItem){
              toast.success("Period info save", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
            else{
              toast.error(foundErrorItem.errorMsg, {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  })
            }
          });
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    }
    const handleClose3=()=>{
      setShow3(false)
    }
    // start
  return (
    <div className="d-flex flexvaluecomp">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Period Entry"/>
          <div className="contentofadmindash contentflexvalue">
            <Row>
                <Col lg={8} className="m-auto">
                <Row>
                    <Col >
                        <div className="basicinput">
                            <p></p>
                            <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus />Add New Period</button>
                        </div>
                    </Col>
                    
                    <Col>
                    <div className="basicinput">
                    <p>Start Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrom}
                          onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Start Date"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                    <Col >
                    <div className="basicinput">
                    <p>End Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activeto}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "End Date"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                    <Col lg={5}>
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                </Row>
                
                </Col>
            </Row>
             

              <Row>
                <Col lg={12} className="m-auto">
                  <div className="flexvaluetable periodentrytable">
                    <table>
                      <thead>
                        <tr>
                            {
                              periodEntryApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            PeriodListResponse.item2?PeriodListResponse.item2.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.periodId}</td>
                                  <td>{item.periodName}</td>
                                  <td>{item.description}</td>
                                  <td>{item.session}</td>
                                  <td>{item.startDateFormate}</td>
                                  <td>{item.endDateFormate}</td>
                                  <td>{item.status}</td>
                                  <td>{item.periodYear}</td>
                                  <td>{item.billingLastDate}</td>
                                  <td>{item.discount}</td>
                                  <td>{item.alertStatus}</td>
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src="./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png" alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            }) : ""
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {periodEntryApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
              <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
        {/* Same as */}
        <ToastContainer />
               {/* modal1ori */}

              <Modal dialogClassName="mymodalclsSubjectAdmin" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Period Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        
                        <Col lg={8} className="pr7">
                            <div className="basicinput ">

                                <p>Session Name</p>
                                <div className="inputgap h35">
                                    <input style={bordersessionname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={sessionname} onChange={(e) => setsessionname(e.target.value)} />
                                    <label>{labelsessionname}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="pl7">
                        <div className="basicinput ">

                        <p>Period Name</p>
                        <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderperiodnamemod1} func={drpfunctionperiodnamemod1} myplaceholder={""} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodNameResponse} />
                        </div>
                            <label>{labelperiodnamemod1}</label>
                            
                          
                        </div>
                        </div>
                        </Col>
                        <Col lg={4} className="pr7">
                            <div className="basicinput ">

                                <p>Desc</p>
                                <div className="inputgap h35">
                                    <input style={borderdescmod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={descmod1} onChange={(e) => setdescmod1(e.target.value)} />
                                    <label>{labeldescmod1}</label>
                                </div>
                            </div>
                        </Col>
                      
                        <Col lg={4} className='pl7 pr7'>
                        <div className="basicinput ">

                        <p>Status</p>
                        <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderstatusmod1} func={drpfunctionstatusmod1} myplaceholder={""} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodStatusResponse} />
                        </div>
                            <label>{labelstatusmod1}</label>
                            
                          
                        </div>
                        </div>
                </Col>
                        <Col lg={4} className='pl7'>
                        <div className="basicinput ">

                          <p>Alert Status</p>
                          <div className="inputgap h40">
                          <div className="dropdownwrapper">
                              <Dropdown2 err={borderalertstatusmod1} func={drpfunctionalertstatusmod1} myplaceholder={""} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodAlertStatusResponse} />
                          </div>
                              <label>{labelalertstatusmod1}</label>
                              
                            
                          </div>
                          </div>
                </Col>
                        <Col lg={4} className='pl7'>
                <div className="basicinput">
                    <p>Discount</p>
                    <div className="inputgap h35">
                        <input style={borderdiscountmod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={discountmod1} onChange={(e) => setdiscountmod1(e.target.value)} />
                        <label>{labeldiscountmod1}</label>
                    </div>
                    </div>
                </Col>
                <Col lg={4} className='pl7'>
                    <div className="basicinput">
                        <p>Period Year</p>
                        <div className="inputgap h35">
                            <input style={borderperiodyearmod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={periodyearmod1} onChange={(e) => setperiodyearmod1(e.target.value)} />
                            <label>{labelperiodyearmod1}</label>
                        </div>
                    </div>
                </Col>
                        
                    <Col lg={4} className="d-flex align-items-center">
                    <div className="checkboxfull">
                          <input
                              type="checkbox"
                              value={chkbxsetdefaultmod1}
                              onChange={handlechkbxsetdefaultmod1}
                              id="remember"
                              name="subscribe"
                              checked={chkbxsetdefaultmod1}
                          />
                          <span>Set Default</span>
                      </div>
                    </Col>
                        <Col lg={4} className="pr7">
                  <div className="basicinput modalinputgap">
                    <p>Start Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={startdate}
                          onChange={(newvaldob)=>handlestartdateModal1(newvaldob)}
                          renderInput={(params) => <TextField {...params}
                          style={borderstartdate=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "Start Date"
                            }} error={false} />}
                      />
                      <label>{labelstartdate}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={4} className='pl7 pr7'>
                  <div className="basicinput">
                    <p>End Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={enddate}
                          onChange={(newvaldob)=>handleenddateModal1(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={borderenddate=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "End Date"
                            }} error={false} />}
                      />
                      <label>{labelenddate}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={4} className='pl7 pr7'>
                  <div className="basicinput">
                    <p>Bill Last Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={billlastdatemod1}
                          onChange={(newvaldob)=>handlebilllastdateModal1(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={borderbilllastdatemod1=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "Bill Last Date"
                            }} error={false} />}
                      />
                      <label>{labelbilllastdatemod1}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                

                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>

                {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Period Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        
                        <Col lg={8} className="pr7">
                            <div className="basicinput ">

                                <p>Session Name</p>
                                <div className="inputgap h35">
                                    <input style={bordersessionname2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={sessionname2} onChange={(e) => setsessionname2(e.target.value)} />
                                    <label>{labelsessionname2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className="pl7">
                        <div className="basicinput ">

                        <p>Period Name</p>
                        <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderperiodnamemod2} func={drpfunctionperiodnamemod2} myplaceholder={PeriodNamePopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodNameResponse} />
                        </div>
                            <label>{labelperiodnamemod2}</label>
                            
                          
                        </div>
                        </div>
                        </Col>
                        <Col lg={4} className="pr7">
                            <div className="basicinput ">

                                <p>Desc</p>
                                <div className="inputgap h35">
                                    <input style={borderdescmod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={descmod2} onChange={(e) => setdescmod2(e.target.value)} />
                                    <label>{labeldescmod2}</label>
                                </div>
                            </div>
                        </Col>
                      
                        <Col lg={4} className='pl7 pr7'>
                        <div className="basicinput ">

                        <p>Status</p>
                        <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderstatusmod2} func={drpfunctionstatusmod2} myplaceholder={PeriodStatusPopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodStatusResponse} />
                        </div>
                            <label>{labelstatusmod2}</label>
                            
                          
                        </div>
                        </div>
                </Col>
                        <Col lg={4} className='pl7'>
                        <div className="basicinput ">

                        <p>Alert Status</p>
                        <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderalertstatusmod2} func={drpfunctionalertstatusmod2} myplaceholder={PeriodAlertStatusPopulate} fontsize="12" fontfamily="'Poppins', sans-serif" options={PeriodAlertStatusResponse} />
                        </div>
                            <label>{labelalertstatusmod2}</label>
                            
                          
                        </div>
                        </div>
                </Col>
                        <Col lg={4} className='pl7'>
                <div className="basicinput">
                    <p>Discount</p>
                    <div className="inputgap h35">
                        <input style={borderdiscountmod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={discountmod2} onChange={(e) => setdiscountmod2(e.target.value)} />
                        <label>{labeldiscountmod2}</label>
                    </div>
                    </div>
                </Col>
                <Col lg={4} className='pl7'>
                    <div className="basicinput">
                        <p>Period Year</p>
                        <div className="inputgap h35">
                            <input style={borderperiodyearmod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={periodyearmod2} onChange={(e) => setperiodyearmod2(e.target.value)} />
                            <label>{labelperiodyearmod2}</label>
                        </div>
                    </div>
                </Col>
                        
                <Col lg={4} className="d-flex align-items-center">
                    <div className="checkboxfull">
                          <input
                              type="checkbox"
                              value={chkbxsetdefaultmod2}
                              onChange={handlechkbxsetdefaultmod2}
                              id="remember"
                              name="subscribe"
                              checked={chkbxsetdefaultmod2}
                          />
                          <span>Set Default</span>
                      </div>
                    </Col>
                        <Col lg={4} className="pr7">
                  <div className="basicinput modalinputgap">
                    <p>Start Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={startdate2}
                          onChange={(newvaldob)=>handlestartdateModal2(newvaldob)}
                          renderInput={(params) => <TextField {...params}
                          style={borderstartdate2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "Start Date"
                            }} error={false} />}
                      />
                      <label>{labelstartdate2}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={4} className='pl7 pr7'>
                  <div className="basicinput">
                    <p>End Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={enddate2}
                          onChange={(newvaldob)=>handleenddateModal2(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={borderenddate2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "End Date"
                            }} error={false} />}
                      />
                      <label>{labelenddate2}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={4} className='pl7 pr7'>
                  <div className="basicinput">
                    <p>Bill Last Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={billlastdatemod2}
                          onChange={(newvaldob)=>handlebilllastdateModal2(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={borderbilllastdatemod2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "Bill Last Date"
                            }} error={false} />}
                      />
                      <label>{labelbilllastdatemod2}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                

                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose2}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
              </div>
              </div>
              </div>
  )
}

export default PeriodEntryComp